<div class="create-user-modal" *ngIf="isVisible" (click)="closeModal()">
  <div class="create-user-modal__content" (click)="$event.stopPropagation()">
    <h2 class="create-user-modal__title">Add new User</h2>
    <form class="create-user-modal__form" [formGroup]="createUserForm" (ngSubmit)="onSubmit()">
      <div class="create-user-modal__inputs-container">
        <div class="create-user-modal__input-container">
          <input
            type="text"
            formControlName="firstName"
            class="create-user-modal__input"
            placeholder="First Name"
            required
          />
        </div>

        <div class="create-user-modal__input-container">
          <input
            type="text"
            formControlName="lastName"
            class="create-user-modal__input"
            placeholder="Last Name"
            required
          />
        </div>

        <div
          class="create-user-modal__input-container"
          [class.create-user-modal__input-container--error]="
            createUserForm.get('email')?.invalid && createUserForm.get('email')?.touched
          "
        >
          <input type="email" formControlName="email" class="create-user-modal__input" placeholder="Email" required />
        </div>

        <div class="create-user-modal__checkbox">
          <label>
            <input type="checkbox" formControlName="isB2B" />
            Is B2B user
          </label>
        </div>

        <!-- GROUP input -->
        <div class="create-user-modal__input-container" [class.disabled]="!createUserForm.get('isB2B')?.value">
          <input
            type="text"
            formControlName="group"
            class="create-user-modal__input"
            placeholder="Group"
            [disabled]="!createUserForm.get('isB2B')?.value"
          />
        </div>

        <!-- EXPIRATION DATE input -->
        <div class="create-user-modal__input-container" [class.disabled]="!createUserForm.get('isB2B')?.value">
          <label class="create-user-modal__expiry-label" for="expiration-input">Expiration Date</label>
          <div class="create-user-modal__expiry-wrapper" (click)="openDatePicker()">
            <input
              #expiryInput
              id="expiration-input"
              type="date"
              class="create-user-modal__expiry-input"
              formControlName="expirationDate"
            />
          </div>
        </div>

        <div
          *ngIf="createUserForm.get('email')?.invalid && createUserForm.get('email')?.touched"
          class="create-user-modal__error-text"
        >
          Invalid email format
        </div>
      </div>

      <div class="create-user-modal__buttons">
        <app-button variant="main" size="md" [isLoading]="isLoading" [disabled]="isFormInvalid">
          <span *ngIf="isLoading" class="app-spinner app-spinner--inline"></span>
          <span *ngIf="!isLoading">ADD USER</span>
        </app-button>

        <app-button variant="secondary" size="md" (click)="closeModal()">
          <span>CANCEL</span>
        </app-button>
      </div>

      <div *ngIf="errorMessage" class="create-user-modal__error-text create-user__error-message">
        {{ errorMessage }}
      </div>
    </form>
  </div>
</div>
